import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Colors from "../../../styles/colors";
import * as Fonts from "../../../styles/typography";

/**
 * AdminMenuItem - A reusable component for rendering individual menu items
 * in the AdminPanel screen.
 * 
 * @param {string} icon - MaterialCommunityIcons icon name
 * @param {string} title - Display title
 * @param {string} description - Optional description text
 * @param {function} onPress - Callback when item is pressed
 * @param {boolean} isPlaceholder - True if feature not yet implemented
 */
export default function AdminMenuItem({
  icon,
  title,
  description,
  onPress,
  isPlaceholder = false,
}) {
  return (
    <TouchableOpacity
      style={[styles.container, isPlaceholder && styles.placeholderContainer]}
      onPress={onPress}
      activeOpacity={0.7}
    >
      <View style={[styles.iconContainer, isPlaceholder && styles.placeholderIcon]}>
        <Icon
          name={icon}
          size={28}
          color={isPlaceholder ? Colors.GRAY_DARK : Colors.PRIMARY}
        />
      </View>
      <View style={styles.textContainer}>
        <View style={styles.titleRow}>
          <Text style={[styles.title, isPlaceholder && styles.placeholderTitle]}>
            {title}
          </Text>
          {isPlaceholder && (
            <View style={styles.comingSoonBadge}>
              <Text style={styles.comingSoonText}>Em breve</Text>
            </View>
          )}
        </View>
        {description && (
          <Text style={[styles.description, isPlaceholder && styles.placeholderDescription]}>
            {description}
          </Text>
        )}
      </View>
      <Icon
        name="chevron-right"
        size={24}
        color={isPlaceholder ? Colors.GRAY_LIGHT : Colors.GRAY_DARK}
      />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    padding: 16,
    backgroundColor: Colors.WHITE,
    borderBottomWidth: 1,
    borderBottomColor: Colors.GRAY_LIGHT,
  },
  placeholderContainer: {
    opacity: 0.7,
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: Colors.SNOW,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  placeholderIcon: {
    backgroundColor: Colors.GRAY_LIGHT,
  },
  textContainer: {
    flex: 1,
  },
  titleRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  title: {
    fontSize: Fonts.FONT_SIZE_16,
    fontWeight: "bold",
    color: Colors.BLACK,
  },
  placeholderTitle: {
    color: Colors.GRAY_DARK,
  },
  description: {
    fontSize: Fonts.FONT_SIZE_14,
    color: Colors.GRAY_DARK,
    marginTop: 4,
  },
  placeholderDescription: {
    color: Colors.GRAY_LIGHT,
  },
  comingSoonBadge: {
    backgroundColor: Colors.WARNING,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 12,
    marginLeft: 8,
  },
  comingSoonText: {
    fontSize: Fonts.FONT_SIZE_12,
    color: Colors.WHITE,
    fontWeight: "bold",
  },
});
